const hero = {
    "primaryArea": {
        "textTheme": "light",
        "eyebrow": "AT&T THANKS®",
        "heading": "We’re giving back to you – simply because you choose AT&T.",
        "copy1": "Enjoy more of the things you love with none of the fuss, just for being with AT&T.",
        "copy2": "Get great deals on phones and accessories, gift cards, access to sporting events, and more!",
        "cta": {
            "href": "#",
            "icon": "video",
            "id": "watchVideo",
            "label": "Watch Video"
        }
    },
    "secondaryArea": {
        "textTheme": "light",
        "copy": "Sign in to your myAT&T account and check out your benefits now!",
        "cta": {
            "href": "https://www.att.com/olam/loginAction.olamexecute?pId=Passthru_ATT_Thank_You",
            "color": "white",
            "label": "Sign In",
            "id": "signIn",
            "newTab": "false",
            "round": false
        },
        "downloadSection": {
            "heading": "Download the myAT&T app",
            "copy": "AT&T wireless customers can text MYATT to  8758 or click below.",
            "apps": [
                {
                    "icon": "appStore",
                    "url": "https://apps.apple.com/us/app/myat-t/id309172177",
                    "id": "appStore",
                    "altText": "Download on the App Store"
                }, {
                    "icon": "googlePlay",
                    "id": "googlePlay",
                    "url": "https://play.google.com/store/apps/details?id=com.att.myWireless",
                    "altText": "Get it on Google Play"
                }
            ],
            "disclaimer": "myAT&T app: Eligible wireless, TV and Internet customers only; Data/messaging rates may apply for app download and usage. Req’s compatible device with iOS 10 and higher Android™ 5.0 and higher."
        }
    }
}

module.exports = hero;
